import CatRunningReplayTestScreen from './components/CatRunningReplayTestScreen';

export default function CatRunningReplayTestPage() {
  return <CatRunningReplayTestScreen />;
}
